/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = None
 *
 * 1 = Photo
 *
 * 2 = Video
 *
 * 3 = Pdf
 */
export enum MediaTypeEnum {
  None = 0,
  Photo = 1,
  Video = 2,
  Pdf = 3,
}
